import { useState } from "react";
import SearchVisitRequestCard from "../../components/card/SearchVisitRequestCard";
import SearchPassTable from "../../components/table/SearchPassTable";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import { PAGE_SIZE, TABLE_IDS } from "../../constants/common";
import BackButtonWrapper from "../../components/button/BackButton/wrapper";
import { ExportApprovedVisitRequestsForExcelPDFBody } from "../../hooks/visitor/interface";

const ApproveVisitRequest = () => {
  const [exportBody, setExportBody] =
    useState<ExportApprovedVisitRequestsForExcelPDFBody>();

  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const [search, setSearch] = useState("");

  const [allVisitorAppointments, setAllVisitorAppointments] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("approveVisitRequest")}
        </h1>
      </BackButtonWrapper>

      <SearchVisitRequestCard
        setIsLoading={setIsLoading}
        page={page}
        setPages={setPages}
        search={search}
        setCount={setCount}
        setAllVisitorAppointments={setAllVisitorAppointments}
        setExportBody={setExportBody}
        pageSize={pageSize}
      />

      {isLoading && (
        <div className="flex justify-center">
          <Loader />
        </div>
      )}
      
      <SearchPassTable
        allVisitorAppointments={allVisitorAppointments}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        count={count}
        setSearch={setSearch}
        tableId={TABLE_IDS.APPROVE_VISIT_REQUEST}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default ApproveVisitRequest;
